import React, { useEffect, useState } from "react";
import axios from "axios";
import { Header } from "./Landing/Header";
import { Hero, About, Services, WhyUs, Videos, LeadForm, FinalCTA, Footer } from "./Landing/Sections";
import { I18N } from "../mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LandingPage() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("lang");
    return saved === "en" ? "en" : "pt"; // default to PT if not EN
  });

  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);

  useEffect(() => {
    const helloWorldApi = async () => {
      try { await axios.get(`${API}/`); } catch (e) {}
    };
    helloWorldApi();
  }, []);

  useEffect(() => {
    document.title = `MICE Travel — ${I18N[lang].hero.title}`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "Viagens de incentivo corporativas, missões empresariais e operações MICE de alto padrão. Solicite uma proposta.");
  }, [lang]);

  return (
    <div className="bg-black text-white">
      <Header lang={lang} setLang={setLang} />
      <main>
        <Hero lang={lang} />
        <About lang={lang} />
        <Services lang={lang} />
        <WhyUs lang={lang} />
        <Videos lang={lang} />
        <LeadForm lang={lang} />
        <FinalCTA lang={lang} />
      </main>
      <Footer lang={lang} />
    </div>
  );
}
